import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type {
  WebUserGetCurrentOutputDto,
  WebUserGetInfoOutputDto,
} from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import { payload } from '../../../result'
import { formatSessionData, formatUserInfo } from './format'

export function use(
  client: OvpClient,
  session: API['userSession'],
  _api: API
): void {
  // GET /api/web/users/current
  session.checkStatusFx.use(async () => {
    const data = payload<WebUserGetCurrentOutputDto>(
      await client.get.api.web.users.current()
    )

    if (!data) {
      throw new Error('Empty answer in session.checkStatusFx')
    }

    return formatSessionData(data)
  })

  // GET /api/web/users/info
  session.getInfoFx.use(async () => {
    const data = payload<WebUserGetInfoOutputDto>(
      await client.get.api.web.users.info()
    )

    if (!data) {
      throw new Error('Empty answer in session.getInfoFx')
    }

    return formatUserInfo(data)
  })
}
